const isBrowser = typeof window !== 'undefined' && typeof navigator !== 'undefined';
const userAgent = isBrowser ? navigator.userAgent : '';
export const chromeAgent = isBrowser && userAgent.indexOf('Chrome') > -1;
export const safariAgent = isBrowser && userAgent.indexOf('Safari') > -1 && !chromeAgent;
